import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsQuipComponent } from './simple-icons-quip.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsQuipComponent ],
    exports:      [ SimpleIconsQuipComponent ],
    bootstrap:    []
})
export class SimpleIconsQuipModule {}
